export const M365_SCOPES = [
  "offline_access",
  "profile",
  "openid",
  "email",
  "https://graph.microsoft.com/User.Read",
  "https://graph.microsoft.com/User.Read.All",
  "https://graph.microsoft.com/User.ReadBasic.All",
];
